import React from 'react';

import Close from '../Reutilizaveis/CloseButton';

import BoletosParcelas from './Boletos-Parcelas';

import Destaques from './Destaques';

import Videos from './Videos';

import Fotos from './Fotos';

import Agendamentos from './Agendamentos';

import Noticias from './Noticias';

import Aniversario from './Aniversario';

import SurveyResearch from './SurveyResearch';

import ContratoFinanciamento from './ContratoFinanciamento';

import './styles.scss';

const Notificacoes = ({ tema, setNotificationsModal }) => {
  const NOTIFICATIONSPARCELASPENDENTES = JSON.parse(
    sessionStorage.getItem('notificationsParcelasPendentes')
  );

  const NOTIFICATIONSPARCELASVENCIDAS = JSON.parse(
    sessionStorage.getItem('notificationsParcelasVencidas')
  );

  const NOTIFICATIONSBOLETOS = JSON.parse(
    sessionStorage.getItem('notificationsBoletos')
  );

  const NOTIFICATIONSBOLETOSVENCIDOS = JSON.parse(
    sessionStorage.getItem('notificationsBoletosVencidos')
  );

  const tituloFinanceiro = () => {
    if (
      NOTIFICATIONSBOLETOS?.length ||
      NOTIFICATIONSBOLETOSVENCIDOS?.length ||
      NOTIFICATIONSPARCELASPENDENTES?.length ||
      NOTIFICATIONSPARCELASVENCIDAS?.length
    )
      return true;
  };

  return (
    <div className='centralized-column' style={{ position: 'relative' }}>
      <span
        className='close-notifications-modal'
        onClick={() => {
          setNotificationsModal(false);
        }}
      >
        <Close corBackground='#ffffff' tamanho={32} />
      </span>
      <div className='notifications'>
        <span
          className='notifications__title'
          style={{ color: tema.primaryColor }}
        >
          Notificações
        </span>

        <SurveyResearch
          tema={tema}
          setNotificationsModal={setNotificationsModal}
        />

        <ContratoFinanciamento
          tema={tema}
          setNotificationsModal={setNotificationsModal}
        />

        <Aniversario tema={tema} />
        <Destaques tema={tema} setNotificationsModal={setNotificationsModal} />

        {/* boletos */}

        {tituloFinanceiro() && (
          <span
            className='notifications__item__title'
            style={{
              color: tema.primaryColor,
              marginBottom: '-8px',
              marginTop: '24px',
            }}
          >
            Financeiro:
          </span>
        )}

        <BoletosParcelas
          vencidas={NOTIFICATIONSBOLETOSVENCIDOS}
          tema={tema}
          setNotificationsModal={setNotificationsModal}
          tipo='boleto'
          mostrarTitulo
        />
        <BoletosParcelas
          vencidas={NOTIFICATIONSPARCELASVENCIDAS}
          tema={tema}
          setNotificationsModal={setNotificationsModal}
          tipo='parcela'
          // mostrarTitulo={false}
        />

        <BoletosParcelas
          pendentes={NOTIFICATIONSBOLETOS}
          tema={tema}
          setNotificationsModal={setNotificationsModal}
          tipo='boleto'
          // mostrarTitulo={false}
        />
        <BoletosParcelas
          pendentes={NOTIFICATIONSPARCELASPENDENTES}
          tema={tema}
          setNotificationsModal={setNotificationsModal}
          tipo='parcela'
          // mostrarTitulo={false}
        />

        <Fotos tema={tema} setNotificationsModal={setNotificationsModal} />

        <Noticias tema={tema} setNotificationsModal={setNotificationsModal} />

        <Agendamentos
          tema={tema}
          setNotificationsModal={setNotificationsModal}
        />

        <Videos tema={tema} setNotificationsModal={setNotificationsModal} />
      </div>
    </div>
  );
};

export default Notificacoes;
